// 课后拓展 接管数据
export default {
  workList:'',
  delWork:'',
  delWorkList:'',
  editWork:'',
  addWork:{},
  getWorkId:[],
  getWorkFj:[],
  postWork:'',
  workTopic:{},
  notSumbitList:[],
  notSumbitListTotal:'',
  getIdScoring:{},
  getIdScoringFj:{},
  editIdScoring:{},
  editEditScoring:{},
  batchTotal:{},
  batchReject:{},
  exportExcel:{},
  remindStudent:{},
  workinfo:{}
}
